import {Chip, Typography} from '@mui/material';

export const QALabel = ({label}: {label: string}) => {
  return (
    <Chip
      label={
        <Typography
          className="typo-text label4_size text-body-strong"
          data-testid={`question-ans-panel-${label}`}
        >
          {label}
        </Typography>
      }
      size="small"
      className="q-a-Label-Chip"
    />
  );
};
